/**
 * Created by mac on 7/23/18
 */

const MissionManager = function () {
    cleverapps.EventEmitter.call(this);
    this.missions = [];
    this.teaser = undefined;
    this.unknownMissionsData = [];
    this.lastRemoved = {};

    this.semaphoresOnHold = 0;

    connector.metrics.on("startDay", this.flushDailyRewards.bind(this));
};

MissionManager.prototype = Object.create(cleverapps.EventEmitter.prototype);
MissionManager.prototype.constructor = MissionManager;

MissionManager.prototype.flushDailyRewards = function () {
    const all = cleverapps.dataLoader.load(DataLoader.TYPES.MISSIONS_DAILY_REWARD) || {};
    Object.keys(all).forEach((missionType) => {
        const entry = all[missionType];
        const name = Missions[missionType] && Missions[missionType].name;
        cleverapps.metrics.logEvent(`${Mission.EVENTS.MISSION_REWARD}${entry.max}${name}`, { event: entry.day });
        delete all[missionType];
    });
    cleverapps.dataLoader.save(DataLoader.TYPES.MISSIONS_DAILY_REWARD, all);
};

MissionManager.prototype.isObsoleteMissionType = function (type) {
    return Mission.OBSOLETE_TYPES.indexOf(Mission.GetMissionType(type)) !== -1;
};

MissionManager.prototype.canCreateType = function (type) {
    const missionData = Missions[type];
    if (!missionData) {
        return false;
    }

    const existingTypes = this.getExistingTypes();
    if (!existingTypes.includes(type)) {
        return false;
    }

    if (missionData.location && !cleverapps.meta.isLocationAvailable(missionData.location)) {
        return false;
    }

    let available = missionData.available || {};
    available = available[cleverapps.config.name] || available;
    available = available[connector.info.source] || available;

    if (available.projectName && cleverapps.toArray(available.projectName).indexOf(cleverapps.config.name) === -1) {
        return false;
    }

    if (cleverapps.config.demoMode) {
        return true;
    }

    if (available.debugMode && !cleverapps.config.debugMode) {
        return false;
    }

    if (available.disabled) {
        return false;
    }

    return true;
};

MissionManager.prototype.init = function () {
    this.reset();
    this.load(cleverapps.dataLoader.load(DataLoader.TYPES.MISSIONS));

    cleverapps.abExperiments.whenGroupsUpdated(() => {
        this.refreshByABExperiments();
    });
};

MissionManager.prototype.refreshByABExperiments = function () {
    this.missions.slice().forEach((mission) => {
        const missionData = Missions[mission.type];
        if (missionData.abTest && !missionData.abTest()) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.MISSION_AB_REMOVE, {
                itemId: mission.getName(),
                value: mission.result
            });
            this.remove(mission);
        }
    });
};

MissionManager.prototype.migrateOldData = function (data) {
    const missions = Array.isArray(data) ? data : data.missions || [];

    Object.keys(data.lastRemoved || {}).forEach((type) => {
        missions.push({
            type: cleverapps.castType(type),
            lastRemoved: data.lastRemoved[type]
        });
    });

    const LEGACY_LOCATIONS = {
        32: { locationId: "dragonia", version: 0, slot: "2" },
        "32v1": { locationId: "dragonia", version: 1, slot: "2" },
        40: { locationId: "undersea", version: 0, slot: "2" },
        "40v1": { locationId: "undersea", version: 1, slot: "2" },
        46: { locationId: "undersea2", version: 0, slot: "2" },
        "46v1": { locationId: "undersea2", version: 1, slot: "2" },
        48: { locationId: "rapunzel", version: 0, slot: "2" },
        49: { locationId: "dragonia2", version: 0, slot: "2" },
        52: { locationId: "rapunzel2", version: 0, slot: "2" },
        55: { locationId: "easter", version: 0, slot: "1" },
        "55v1": { locationId: "easter", version: 1, slot: "1" },
        "55v2": { locationId: "easter", version: 2, slot: "1" },
        58: { locationId: "adventure", version: 0, slot: "4" },
        59: { locationId: "dragonia3", version: 0, slot: "2" },
        60: { locationId: "halloween", version: 0, slot: "1" },
        "60v1": { locationId: "halloween", version: 1, slot: "1" },
        "60v2": { locationId: "halloween", version: 2, slot: "1" },
        61: { locationId: "xmas", version: 0, slot: "1" },
        "61v1": { locationId: "xmas", version: 1, slot: "1" },
        "61v2": { locationId: "xmas", version: 2, slot: "1" },
        "61v3": { locationId: "xmas", version: 3, slot: "1" },
        62: { locationId: "rapunzel3", version: 0, slot: "2" },
        63: { locationId: "china", version: 0, slot: "1" },
        "63v1": { locationId: "china", version: 1, slot: "1" },
        68: { locationId: "undersea3", version: 0, slot: "2" },
        69: { locationId: "adventure2", version: 0, slot: "4" },
        71: { locationId: "blackfriday", version: 0, slot: "5" },
        "71v1": { locationId: "blackfriday", version: 1, slot: "5" },
        72: { locationId: "spring", version: 0, slot: "1" },
        73: { locationId: "july4", version: 0, slot: "1" },
        75: { locationId: "summerpets", version: 0, slot: "1" },
        "75v1": { locationId: "summerpets", version: 1, slot: "1" },
        76: { locationId: "laborday", version: 0, slot: "1" },
        79: { locationId: "startale", version: 0, slot: "1" },
        80: { locationId: "adventure3", version: 0, slot: "4" }
    };

    for (let i = 0; i < missions.length;) {
        const mission = missions[i];
        const legacyLocation = LEGACY_LOCATIONS[mission.type];

        if (!legacyLocation) {
            i++;
            continue;
        }

        this.needSaveAfterMigration = true;

        missions.splice(i, 1);

        const locationMeta = cleverapps.meta.getLocationMeta(legacyLocation.locationId);
        if (!locationMeta.isUnknown() && !locationMeta.isStarted() && !locationMeta.isFinished()) {
            if (mission.started) {
                locationMeta.updateInfo({
                    version: legacyLocation.version,
                    slot: legacyLocation.slot,
                    started: mission.started
                });
                cleverapps.meta.needSaveAfterMigration = true;
            } else if (mission.lastRemoved) {
                locationMeta.updateInfo({
                    version: legacyLocation.version,
                    slot: legacyLocation.slot,
                    finished: mission.lastRemoved
                });
                cleverapps.meta.needSaveAfterMigration = true;
            }
        }
    }

    return missions;
};

MissionManager.prototype.load = function (data, fromServer) {
    const missions = this.migrateOldData(data || []);

    for (let index = 0; index < missions.length; index++) {
        const mission = missions[index];

        if (this.isObsoleteMissionType(mission.type)) {
            continue;
        }

        if (!this.canCreateType(mission.type)) {
            this.handleUnknownType(mission);
            continue;
        }

        if (this.findByType(mission.type)) {
            continue;
        }

        if (!MissionManager.inActiveLocation(mission.type)) {
            continue;
        }

        if (mission.lastRemoved !== undefined) {
            this.setLastRemoved(mission.type, mission.lastRemoved);
            continue;
        }

        if (mission.started === -1) {
            this.setTeaser(mission.type);
            continue;
        }

        if (!this.canUseSemaphore(mission.type)) {
            continue;
        }

        this.add(mission.type, mission, fromServer);
        delete this.lastRemoved[mission.type];
    }

    this.save(fromServer);
};

MissionManager.prototype.handleUnknownType = function (data) {
    this.unknownMissionsData.push(data);
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.DEBUG.UNKNOWN_MISSION_DAU);
};

MissionManager.prototype.getPlayableMissions = function () {
    return this.missions.filter((mission) => mission.isRunning() && mission.canPlayMinigame());
};

MissionManager.prototype.findLocalPass = function () {
    for (let i = 0; i < this.missions.length; i++) {
        const mission = this.missions[i];
        if (mission.isPassMission() && MissionManager.hasProperLocation(mission.type) && mission.isRunning()) {
            return mission;
        }
    }

    return undefined;
};

MissionManager.prototype.findRunningMission = function (type) {
    const types = cleverapps.createSet(cleverapps.toArray(type) || []);

    for (let i = 0; i < this.missions.length; i++) {
        if (this.missions[i].isRunning() && types[this.missions[i].type]) {
            return this.missions[i];
        }
    }

    return undefined;
};

MissionManager.prototype.getRunningMissions = function () {
    return this.missions.filter((mission) => mission.isRunning());
};

MissionManager.prototype.findBySemaphore = function (semaphore) {
    for (let i = 0; i < this.missions.length; ++i) {
        const mission = this.missions[i];
        // eslint-disable-next-line no-bitwise
        if (mission.isRunning() && mission.isUnlocked() && (mission.semaphore & semaphore)) {
            return mission;
        }
    }
};

MissionManager.prototype.findByType = function (type) {
    type = cleverapps.castType(type);

    for (let i = 0; i < this.missions.length; i++) {
        if (this.missions[i].type === type) {
            return this.missions[i];
        }
    }

    return undefined;
};

MissionManager.prototype.skipNext = function () {
    return this.missions.filter((mission) => mission.skipNext()).length > 0;
};

MissionManager.prototype.getMissionWithIntent = function () {
    for (const i in this.missions) {
        const mission = this.missions[i];
        if (mission.logic && mission.logic.hasIntent && mission.logic.hasIntent()) {
            return mission;
        }
    }
    return undefined;
};

MissionManager.prototype.dispatchEvent = function (missionOrType, options) {
    const mission = (typeof missionOrType === "object") ? missionOrType : this.findByType(missionOrType);

    if (mission && mission.isRunning()) {
        mission.logic.processEvent(options);
        return true;
    }

    return false;
};

MissionManager.prototype.reset = function () {
    for (let i = 0; i < this.missions.length; ++i) {
        const mission = this.missions[i];

        this.trigger("remove", mission);
        this.removeMissionIcon(mission);

        this.refreshOffer(mission);

        mission.destructor();
    }

    this.missions = [];

    this.setTeaser(undefined);

    this.unknownMissionsData = [];
    this.lastRemoved = {};
    this.semaphoresOnHold = 0;
};

MissionManager.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.MISSIONS, this.getInfo());
    if (!fromServer) {
        this.addUpdateTask();
    }
};

MissionManager.prototype.sendUpdateTask = function () {
    if (MissionManager.sendUpdateTimeout !== undefined) {
        clearTimeout(MissionManager.sendUpdateTimeout);
        MissionManager.sendUpdateTimeout = undefined;
    }
    connector.synchronizer.addSendTask("missions");
};

MissionManager.prototype.addUpdateTask = function () {
    if (!["merge", "merge2"].includes(cleverapps.config.type) && Game.currentGame && Game.currentGame.outcome === GameBase.OUTCOME_UNKNOWN) {
        if (MissionManager.sendUpdateTimeout === undefined && !cleverapps.environment.isSceneWithPreview()) {
            MissionManager.sendUpdateTimeout = setTimeout(this.sendUpdateTask.bind(this), cleverapps.parseInterval("1 minute"));
        }

        if (!Game.currentGame.missionManagerStopHandler) {
            Game.currentGame.missionManagerStopHandler = Game.currentGame.on("stop", () => {
                if (MissionManager.sendUpdateTimeout !== undefined) {
                    this.sendUpdateTask();
                }
            });
        }
        return;
    }
    this.sendUpdateTask();
};

MissionManager.prototype.getInfo = function () {
    const missions = [];
    const used = {};

    this.missions.forEach((mission) => {
        missions.push(mission.save());
        used[mission.type] = true;
    });

    this.unknownMissionsData.forEach((mission) => {
        missions.push(mission);
    });

    Object.keys(this.lastRemoved).forEach(function (type) {
        if (used[type]) {
            return;
        }
        missions.push({
            type: cleverapps.castType(type),
            lastRemoved: this.lastRemoved[type]
        });
        used[type] = true;
    }, this);

    return missions;
};

MissionManager.prototype.updateInfo = function (data, fromServer) {
    console.log("updateInfo", data);

    this.reset();
    this.load(data, fromServer);
};

MissionManager.prototype.removeSilents = function () {
    while (true) {
        let hasSilent = false;

        for (let i = 0; i < this.missions.length; i++) {
            const mission = this.missions[i];
            if (mission.isCompleted() && mission.canRemoveSilently()) {
                hasSilent = true;
                this.remove(mission);
                break;
            }
        }

        if (!hasSilent) {
            break;
        }
    }
};

MissionManager.prototype.wantsToShowCompleted = function () {
    return this.missions.find((mission) => {
        if (!mission.isCompleted() || mission.tillTheTimeEnds && mission.getTimeLeft() !== 0 || mission.canRemoveSilently() || mission.wasDisplayedCompleted) {
            return false;
        }

        return MissionManager.hasProperLocation(mission.type);
    });
};

MissionManager.prototype.getWantToShowNewStateMission = function () {
    return this.missions.find((mission) => mission.logic && mission.logic.wantToShowNewState && mission.logic.wantToShowNewState());
};

MissionManager.prototype.pendingStartWindow = function () {
    for (let i = 0; i < this.missions.length; i++) {
        const mission = this.missions[i];
        if (this.hasPendingStartWindow(mission) && (!Missions[mission.type].available || cleverapps.user.checkAvailable(Missions[mission.type].available))) {
            return mission;
        }
    }
};

MissionManager.prototype.hasPendingStartWindow = function (mission) {
    return mission && mission.isRunning() && mission.needShowStartWindow && mission.startWindow && MissionManager.hasProperLocation(mission.type);
};

MissionManager.prototype.showStartWindow = function (mission) {
    cleverapps.focusManager.display({
        focus: `missionStartWindow${mission.name}`,
        actions: [
            function (f) {
                if (!mission.unitStory) {
                    f();
                    return;
                }

                const unitStory = Map2dLocation.currentLocation.unitStories.findStory(mission.unitStory.unit ? Unit.GetKey(mission.unitStory.unit) : mission.unitStory.storyKey);
                if (unitStory) {
                    if (mission.logic && mission.logic.customSpawn) {
                        mission.logic.customSpawn();
                    }

                    if (cleverapps.missionManager.getLastRemoved(mission.type)) {
                        const unit = mission.unitStory.unit && Map2d.currentMap.listAvailableUnits(mission.unitStory.unit)[0];
                        if (unit) {
                            Map2d.currentMap.focusOnUnit(unit, {
                                allowScrollWithFocus: true,
                                delay: (mission.unitStory.delay || 0) / 1000,
                                callback: f
                            });
                        } else {
                            f();
                        }
                        return;
                    }

                    Map2dLocation.currentLocation.unitStories.showUnitStory(f, unitStory.dialogue, {
                        unit: mission.unitStory.unit && Map2d.currentMap.listAvailableUnits(mission.unitStory.unit)[0],
                        delay: mission.unitStory.delay || 0
                    });
                } else {
                    cleverapps.throwAsync(`Missing unitStory: ${JSON.stringify(mission.unitStory)}`);
                    f();
                }
            },

            function (f) {
                mission.skipStartWindow();
                if (mission.startWindow === GuideWindow) {
                    cleverapps.focusManager.compound(f, [
                        (f) => {
                            GuideWindow.createMissionRulesWindow(mission);

                            f();
                        },

                        (f) => {
                            if (mission.nudgeWindow) {
                                const NudgeWindow = mission.nudgeWindow;
                                new NudgeWindow(mission);

                                cleverapps.focusManager.onceNoWindowsListener = f;
                            } else if (mission.nudgeScene) {
                                const NudgeScene = mission.nudgeScene;
                                const nudgeScene = NudgeScene instanceof VirtualJson ? Prefab.instantiate(NudgeScene, { args: [mission] }) : new NudgeScene(mission);
                                cleverapps.scenes.replaceScene(nudgeScene, f);
                            } else {
                                f();
                            }
                        }
                    ]);
                } else {
                    cleverapps.focusManager.compound(f, [
                        (f) => {
                            const StartWindow = mission.startWindow;
                            new StartWindow(mission);

                            cleverapps.focusManager.onceNoWindowsListener = f;
                        },
                        (f) => {
                            const offer = cleverapps.offerManager.findOffer({ mission: mission.type });

                            if (offer && !offer.offerWindowShown) {
                                cleverapps.offerManager.showOfferWindow(offer);
                            }

                            f();
                        }
                    ]);
                }
                const tutorialScenario = mission.tutorialScenario && cleverapps.tutorial.findScenario(mission.tutorialScenario);
                if (tutorialScenario && tutorialScenario.isAvailable()) {
                    cleverapps.tutorial.startScenario(tutorialScenario);
                }
            },

            function (f) {
                if (mission.tutorial && Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial) {
                    Map2dLocation.currentLocation.tutorial.showTutorial(mission.tutorial, f);
                } else {
                    f();
                }
            }
        ]
    });
};

MissionManager.prototype.getExistingTypes = function () {
    const types = this._getExistingTypes();

    return types.filter((type) => {
        if (connector.platform.oneOf(connector.GDCOM, connector.COOLMATHGAMES)) {
            return [Mission.TYPE_LIVESFEAST, Mission.TYPE_SOFTFEAST,
                Mission.TYPE_KRAKENFEAST, Mission.TYPE_SNAIL_FEAST, Mission.TYPE_EXPEDITION_FEAST, Mission.TYPE_SLOT_MACHINE].indexOf(type) === -1;
        }
        return true;
    });
};

MissionManager.prototype._getExistingTypes = function () {
    if (this.existingTypes) {
        return this.existingTypes;
    }

    const types = [...Mission.REGISTRATIONS.keys()];

    this.existingTypes = types.filter((type) => {
        const missionData = Missions[type];
        if (!missionData) {
            return false;
        }

        if (missionData.location && !cleverapps.meta.isLocationAvailable(missionData.location)) {
            return false;
        }

        return true;
    }).map((type) => cleverapps.castType(type));

    return this.existingTypes;
};

MissionManager.prototype.isAvailableByType = function (type, options) {
    options = options || {};

    if (Missions[type].needsPayments && !Product.HasPaymentMethod()) {
        return false;
    }

    const feature = Missions[type].feature;
    if (feature && !cleverapps.eventManager.isActive(feature)) {
        return false;
    }

    const unit = Missions[type].unit;
    if (unit) {
        if (!cleverapps.unitsLibrary.isOpened(unit)) {
            return false;
        }
    }

    const available = cleverapps.clone(Missions[type].available || {}, true);

    if (options.teaser) {
        if (["merge", "merge2"].includes(cleverapps.config.type)) {
            available.level--;
        } else if (available.actualLevel) {
            available.actualLevel = Math.max(1, available.actualLevel - 5);
        } else if (available.level) {
            available.level = Math.max(0, available.level - 0.66);
        }
    }

    return cleverapps.user.checkAvailable(available);
};

MissionManager.prototype.canUseSemaphore = function (type) {
    let usedSemaphore = 0;
    for (let i = 0; i < this.missions.length; i++) {
        usedSemaphore |= this.missions[i].semaphore;
    }
    for (let i = 0; i < this.unknownMissionsData.length; i++) {
        usedSemaphore |= this.unknownMissionsData[i].semaphore || 0;
    }
    if (this.semaphoresOnHold) {
        usedSemaphore |= this.semaphoresOnHold;
    }
    return (usedSemaphore & Missions[type].semaphore) === 0;
};

MissionManager.prototype.hasCompetitions = function () {
    const existingTypes = this.getExistingTypes();
    for (let i = 0; i < existingTypes.length; i++) {
        const missionData = Missions[existingTypes[i]];
        if (missionData.competition) {
            return true;
        }
    }

    return false;
};

MissionManager.prototype.canCreateTypes = function () {
    const existingTypes = this.getExistingTypes();

    let availableTypes = existingTypes.filter((type) => this.isAvailableByType(type));

    let availableTeasers = existingTypes.filter((type) => Missions[type].teaser && availableTypes.indexOf(type) === -1 && this.isAvailableByType(type, { teaser: true }));

    const availableBots = cleverapps.bots.getAmount();

    const filterTypes = function (type) {
        const missionData = Missions[type];

        if (missionData.semaphore === 0 && this.findByType(type)) {
            return false;
        }

        if (missionData.manualStart) {
            return false;
        }

        if (missionData.abTest && !missionData.abTest()) {
            return false;
        }

        if (missionData.canStart && !missionData.canStart()) {
            return false;
        }

        if (!MissionManager.hasProperLocation(type)) {
            return false;
        }

        let lastRemoved = this.getLastRemoved(type);

        if (missionData.schedule) {
            const { startDate, endDate } = MissionManager.parseWeekdayRange(missionData.schedule);
            if (Date.now() < startDate.getTime() || Date.now() >= endDate.getTime()) {
                return false;
            }

            if (lastRemoved >= endDate.getTime()) {
                return false;
            }
        }

        if (missionData.disabledNewMission) {
            return false;
        }

        if (lastRemoved) {
            if (missionData.oneShot) {
                return false;
            }
            const cooldown = missionData.cooldown && cleverapps.parseInterval(missionData.cooldown);
            if (cooldown && (lastRemoved + cooldown > Date.now())) {
                return false;
            }
            if (missionData.oncePerEvent && missionData.feature) {
                const event = cleverapps.eventManager.getFeatureEvent(missionData.feature);
                if (lastRemoved >= event.finish.getTime()) {
                    return false;
                }
            }
        }

        const semaphoreCooldown = Mission.SEMAPHORE_COOLDOWNS[missionData.semaphore];
        if (semaphoreCooldown) {
            let lastRemovedSemaphore = 0;

            for (const finishedType in this.lastRemoved) {
                if (Missions[finishedType].semaphore === missionData.semaphore) {
                    lastRemoved = this.getLastRemoved(finishedType);
                    if (lastRemoved > lastRemovedSemaphore) {
                        lastRemovedSemaphore = lastRemoved;
                    }
                }
            }

            if (lastRemovedSemaphore + cleverapps.parseInterval(semaphoreCooldown) > Date.now()) {
                return false;
            }
        }

        const needBots = missionData.competition && missionData.competition.amount && missionData.competition.amount[1] || 0;
        return this.canUseSemaphore(type) && needBots <= availableBots;
    }.bind(this);

    const sortTypes = function (type1, type2) {
        if (this.teaser === type1) {
            return -1;
        }
        if (this.teaser === type2) {
            return 1;
        }

        const lastRemoved1 = this.lastRemoved[type1] || 0;
        const lastRemoved2 = this.lastRemoved[type2] || 0;
        return lastRemoved1 - lastRemoved2;
    }.bind(this);

    availableTypes = availableTypes.filter(filterTypes);
    availableTypes.sort(sortTypes);

    availableTeasers = availableTeasers.filter(filterTypes);
    availableTeasers.sort(sortTypes);

    return {
        missions: availableTypes,
        teasers: availableTeasers
    };
};

MissionManager.hasProperLocation = function (missionType) {
    const missionData = Missions[missionType];
    if (!missionData) {
        return false;
    }

    if (cleverapps.environment.isEditorScene()) {
        return false;
    }

    if (missionData.allLocations) {
        return true;
    }

    if (missionData.location) {
        return missionData.location === cleverapps.meta.selectedLocationId();
    }

    return cleverapps.meta.getSelectedLocation().locationConfig.isMain;
};

MissionManager.inActiveLocation = function (missionType) {
    const missionData = Missions[missionType];
    if (!missionData) {
        return false;
    }

    if (missionData.location) {
        return cleverapps.meta.isLocationActive(missionData.location);
    }

    return true;
};

MissionManager.prototype.planMission = function (missionType) {
    this.next = missionType;
};

MissionManager.prototype.run = function () {
    const available = this.canCreateTypes();

    const mission = this.next === undefined ? available.missions[0] : this.next;
    this.next = undefined;

    if (mission !== undefined) {
        this.add(mission);

        if (this.teaser === mission) {
            this.setTeaser(undefined);
        }

        this.save();
    }

    this.runManualMissions();
};

MissionManager.prototype.showTeaser = function () {
    const available = this.canCreateTypes();

    const mission = this.next === undefined ? available.missions[0] : this.next;

    const teaser = available.teasers.length > 0 && available.teasers[0];
    if (teaser && (!mission || teaser.semaphore !== mission.semaphore)) {
        this.setTeaser(teaser);
    }
};

MissionManager.prototype.setTeaser = function (teaser) {
    if (this.teaser) {
        this.removeTeaserIcon();
    }

    this.teaser = teaser;

    if (this.teaser) {
        this.addTeaserIcon();
    }
};

MissionManager.prototype.runManualMissions = function () {
    this.getExistingTypes()
        .filter((type) => Missions[type].autoStart !== false)
        .forEach((type) => {
            this.manualStart(type);
        });
};

MissionManager.prototype.canManualStart = function (type, options) {
    const missionData = Missions[type];
    const starter = missionData && missionData.manualStart;

    if (!starter || !MissionManager.hasProperLocation(type)) {
        return false;
    }

    if (this.findByType(type) !== undefined) {
        return false;
    }

    if (missionData.available && !cleverapps.user.checkAvailable(missionData.available)) {
        return false;
    }

    if (missionData.abTest && !missionData.abTest()) {
        return false;
    }

    return starter(type, options || {});
};

MissionManager.prototype.manualStart = function (type, options) {
    if (!this.canManualStart(type, options)) {
        return;
    }

    const mission = this.add(type);
    this.save();

    return mission;
};

MissionManager.prototype.remove = function (mission) {
    mission.stop();
    mission.destructor();

    const index = this.missions.indexOf(mission);
    if (index === -1) {
        return;
    }

    if (mission.semaphore) {
        // eslint-disable-next-line no-bitwise
        this.semaphoresOnHold |= mission.semaphore;
        setTimeout(() => {
            // release semaphore after short time
            // eslint-disable-next-line no-bitwise
            if (this.semaphoresOnHold & mission.semaphore) {
                this.semaphoresOnHold -= mission.semaphore;
            }
        }, cleverapps.parseInterval("1 minute"));
    }

    this.missions.splice(index, 1);

    mission.logEvent(Mission.EVENTS.MISSION_END, { itemId: mission.rewardsReceived ? "rewarded" : "no_reward" });

    let finishDate = mission.oncePerEvent ? mission.eventFinishTime : Date.now();

    if (mission.schedule) {
        finishDate = mission.finishTime();
    }

    this.setLastRemoved(mission.type, finishDate);

    this.save();

    this.trigger("remove", mission);
    this.removeMissionIcon(mission);

    this.refreshOffer(mission);

    if (cleverapps.toolModel) {
        cleverapps.toolModel.refresh();
    }
};

MissionManager.prototype.add = function (type, data, fromServer) {
    const mission = new Mission(type, data, fromServer);
    this.missions.push(mission);

    this.trigger("add", mission);

    mission.on("changed", () => this.save());

    this.addMissionIcon(mission);

    this.refreshOffer(mission, !data);

    if (mission.isRunning()) {
        mission.logEvent(Mission.EVENTS.MISSION_DAU, { once: true });
    }

    if (cleverapps.toolModel) {
        cleverapps.toolModel.refresh();
    }

    return mission;
};

MissionManager.prototype.complete = function (mission) {
    this.trigger("complete", mission);

    if (mission.isCompetitionMission() && !mission.stages && mission.getSummary().place === 0) {
        mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
    }

    if (mission.logic && mission.logic.onComplete) {
        mission.logic.onComplete();
    }

    this.refreshOffer(mission);
};

MissionManager.prototype.listLocationMissions = function (locationId) {
    return this.missions.filter((mission) => mission.location === locationId);
};

MissionManager.prototype.clearLocationMissions = function (locationId) {
    this.missions.forEach((mission) => {
        if (mission.location === locationId) {
            cleverapps.missionManager.remove(mission);
        }
    });

    Object.keys(this.lastRemoved).forEach((type) => {
        const missionData = Missions[type];
        if (missionData && missionData.location === locationId) {
            delete this.lastRemoved[type];
        }
    });

    this.save();
};

MissionManager.prototype.refreshOffer = function (mission, isNew) {
    cleverapps.offerManager.refreshByMission(mission.type, isNew);
};

MissionManager.prototype.getLastRemoved = function (type) {
    const lastRemoved = this.lastRemoved[type];
    if (lastRemoved !== undefined) {
        return lastRemoved;
    }
    return 0;
};

MissionManager.prototype.setLastRemoved = function (type, finishDate) {
    this.lastRemoved[type] = finishDate;
};

MissionManager.prototype.addTeaserIcon = function () {
    const icon = new TeaserIcon(this.teaser);
    cleverapps.sideBar.addTemporaryIcon(icon);
};

MissionManager.prototype.removeTeaserIcon = function () {
    const icon = cleverapps.sideBar.findTeaserIcon();
    cleverapps.sideBar.removeTemporaryIcon(icon);
};

MissionManager.prototype.addMissionIcon = function (mission) {
    this.updateMissionIcon(mission);
};

MissionManager.prototype.removeMissionIcon = function (mission) {
    this.updateMissionIcon(mission, true);
};

MissionManager.prototype.updateMissionIcons = function () {
    this.missions.forEach((mission) => {
        this.updateMissionIcon(mission);
    });
};

MissionManager.prototype.updateMissionIcon = function (mission, removed) {
    if (removed || this.missions.indexOf(mission) !== -1) {
        this.updateSideBarMissionIcon(mission, removed);
        this.updateExtraBarMissionIcon(mission, removed);
    }
};

MissionManager.prototype.updateSideBarMissionIcon = function (mission, removed) {
    if (mission.sideBarJson === false) {
        return;
    }

    let sideBarIcon = cleverapps.sideBar.findMissionIcon(mission.type);

    if (removed) {
        if (sideBarIcon) {
            cleverapps.sideBar.removeTemporaryIcon(sideBarIcon);
        }
    } else if (!sideBarIcon) {
        sideBarIcon = new MissionIcon(mission);
        cleverapps.sideBar.addTemporaryIcon(sideBarIcon);
    } else {
        sideBarIcon.resetState();
    }
};

MissionManager.prototype.updateExtraBarMissionIcon = function (mission, removed) {
    if (!cleverapps.extraBar || !mission.extraBarIcon) {
        return;
    }

    let extraBarIcon = cleverapps.extraBar.listIcons().find((icon) => icon instanceof MissionIcon && icon.mission.type === mission.type);

    if (removed || !MissionIcon.IsAvailable(mission)) {
        if (extraBarIcon) {
            cleverapps.extraBar.removeIcon(extraBarIcon);
        }
    } else if (!extraBarIcon) {
        extraBarIcon = new MissionIcon(mission);
        cleverapps.extraBar.addIcon(extraBarIcon);
    } else {
        extraBarIcon.resetState();
    }
};

MissionManager.WEEKDAYS = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

MissionManager.expandSchedule = function (schedule) {
    if (typeof schedule === "string" && schedule.toUpperCase() === "DAILY") {
        return MissionManager.WEEKDAYS.slice();
    }
    if (Array.isArray(schedule)) {
        return schedule;
    }
    return [schedule];
};

MissionManager.weekdayRangeWindow = function (rangeStr, thisMon) {
    const days = MissionManager.WEEKDAYS;
    const tokens = rangeStr.split("-").map((s) => s.trim().toUpperCase());
    const startStr = tokens[0];
    // Single day like "FRI" means the 24h window from FRI 00:00 to SAT 00:00
    const endStr = tokens.length > 1 ? tokens[1] : days[(days.indexOf(startStr) + 1) % 7];

    const startIdx = days.indexOf(startStr);
    const endIdx = days.indexOf(endStr);
    if (startIdx === -1 || endIdx === -1) {
        throw new Error("Invalid weekday name");
    }

    const startDate = new Date(thisMon);
    startDate.setDate(thisMon.getDate() + startIdx);

    const endDate = new Date(thisMon);
    endDate.setDate(thisMon.getDate() + endIdx + (endIdx < startIdx ? 7 : 0));

    return { startDate, endDate };
};

MissionManager.weekStart = function (timestamp) {
    const date = new Date(timestamp);
    date.setHours(0, 0, 0, 0);
    const dow = date.getDay(); // 0=Sun
    date.setDate(date.getDate() - ((dow + 6) % 7));
    return date;
};

// length of one window of the schedule in days: "FRI-MON" is 3, "FRI" or ["FRI", "SAT", "SUN"] is 1, "2 weeks" is 14
MissionManager.scheduleDays = function (schedule) {
    if (MissionManager.isPeriodSchedule(schedule)) {
        return parseInt(schedule) * 7;
    }

    const days = MissionManager.WEEKDAYS;
    const tokens = MissionManager.expandSchedule(schedule)[0].split("-").map((s) => s.trim().toUpperCase());
    if (tokens.length === 1) {
        return 1;
    }
    return (days.indexOf(tokens[1]) - days.indexOf(tokens[0]) + 7) % 7;
};

MissionManager.isPeriodSchedule = function (schedule) {
    return typeof schedule === "string" && /^\d+ weeks?$/.test(schedule);
};

MissionManager.periodRange = function (period, timestamp) {
    const week = cleverapps.parseInterval("1 week");
    const weeks = parseInt(period);

    if (weeks < 1) {
        throw new Error("Invalid schedule period");
    }

    const thisMon = MissionManager.weekStart(timestamp);

    // epoch (1970-01-01) is Thursday, first Monday is 4 days later
    const weeksPassed = Math.round((thisMon.getTime() - cleverapps.parseInterval("4 days")) / week);
    const weekInPeriod = weeksPassed % weeks;

    const startDate = new Date(thisMon);
    startDate.setDate(thisMon.getDate() - weekInPeriod * 7);

    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + weeks * 7);

    return { startDate, endDate };
};

MissionManager.parseWeekdayRange = function (schedule) {
    if (MissionManager.isPeriodSchedule(schedule)) {
        return MissionManager.periodRange(schedule, Date.now());
    }

    const now = Date.now();
    const thisMon = MissionManager.weekStart(now);
    const ranges = MissionManager.expandSchedule(schedule);
    const windows = ranges.map((rangeStr) => MissionManager.weekdayRangeWindow(rangeStr, thisMon));

    const active = windows.find((w) => now >= w.startDate.getTime() && now < w.endDate.getTime());
    if (active) {
        return active;
    }

    const future = windows.filter((w) => w.startDate.getTime() >= now);
    if (future.length > 0) {
        return future.reduce((a, b) => (a.startDate.getTime() <= b.startDate.getTime() ? a : b));
    }

    // All windows this week ended — shift every window by +7 days and pick the earliest
    const nextWeek = windows.map((w) => {
        const startDate = new Date(w.startDate);
        startDate.setDate(startDate.getDate() + 7);
        const endDate = new Date(w.endDate);
        endDate.setDate(endDate.getDate() + 7);
        return { startDate, endDate };
    });
    return nextWeek.reduce((a, b) => (a.startDate.getTime() <= b.startDate.getTime() ? a : b));
};

MissionManager.findWeekdayRange = function (schedule, timestamp) {
    if (MissionManager.isPeriodSchedule(schedule)) {
        return MissionManager.periodRange(schedule, timestamp);
    }

    const thisMon = MissionManager.weekStart(timestamp);
    const ranges = MissionManager.expandSchedule(schedule);
    for (const rangeStr of ranges) {
        const window = MissionManager.weekdayRangeWindow(rangeStr, thisMon);
        if (timestamp >= window.startDate.getTime() && timestamp < window.endDate.getTime()) {
            return window;
        }
    }
    return undefined;
};
